import { render } from "./TestInstructionsStepFour.vue?vue&type=template&id=5230ca0c&scoped=true&ts=true"
import script from "./TestInstructionsStepFour.vue?vue&type=script&lang=ts"
export * from "./TestInstructionsStepFour.vue?vue&type=script&lang=ts"

import "./TestInstructionsStepFour.vue?vue&type=style&index=0&id=5230ca0c&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5230ca0c"]])

export default __exports__